<p>
  termsandconditions works!
</p>
